export default __webpack_public_path__ + "static/media/portfolio-bg-texture_converted.b825036b.jpg";